export default __webpack_public_path__ + "static/media/1.033a1b51.png";